import { render, staticRenderFns } from "./EventHeader.vue?vue&type=template&id=183e1c3f&scoped=true&"
import script from "./EventHeader.vue?vue&type=script&lang=js&"
export * from "./EventHeader.vue?vue&type=script&lang=js&"
import style0 from "./EventHeader.vue?vue&type=style&index=0&id=183e1c3f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183e1c3f",
  null
  
)

export default component.exports